<template>
  <div class="airDetails" v-loading="loading">
    <el-tabs v-model="activeName" type="card" v-if="detailData">
      <el-tab-pane :label="!orderType?'订单详情':orderType=='change'?'改签详情':'退票详情'" name="first">
        <order-info v-if="!orderType" :detailData="detailData"></order-info>
        <change-info v-if="orderType== 'change'" :detailData="detailData"></change-info>
        <refund-info v-if="orderType== 'refund'" :detailData="detailData"></refund-info>
      </el-tab-pane>
      <el-tab-pane :label="!orderType?'订单日志':orderType=='change'?'改签日志':'退票日志'" name="second">
        <el-table :data="tableData" stripe style="width: 100%" border="">
          <el-table-column prop="operatorName" label="操作人" width="180" align="center"></el-table-column>
          <el-table-column prop="operateTime" label="操作时间" width="200" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.operateTime}}</span>
              <!-- <span v-else>{{getDate(scope.row.operateTime)}}</span> -->
            </template>
          </el-table-column>
          <el-table-column label="展示内容" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.text || scope.row.operateEvent}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination
            background=""
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="logListForm.currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="logListForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="logListForm.totalCount"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="flex-center" v-show="activeName=='first'">
      <div v-if="!orderType&&detailData" style="padding:0 15px;">
        <el-button
          type="primary"
          size="small"
          v-if="detailData.orderStatus == 22"
          @click="$router.push({name:'air-ticket-admin-ticketChanging',query:{ordersNo:orderNo,psgType:$route.query.psgType}})"
        >申请改签</el-button>
        <el-button
          type="success"
          size="small"
          v-if="detailData.orderStatus == 22"
          @click="$router.push({name:'air-ticket-admin-dishonour',query:{ordersNo:orderNo,psgType:$route.query.psgType}})"
        >申请退票</el-button>
      </div>
      <el-button type="" size="small" @click="back">返回</el-button>
    </div>
  </div>
</template>
<script>
// 订单查询
const detail = require(`@/lib/data-service/flight/flight_domestic_buyer_manage_order_detail`);
import LogList from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_log_list";
import refundOrderDetail from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_refundDetail";
import changeOrderDetail from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_changeDetail";
import refundLog from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_refundLog";
import changeLog from "@/lib/data-service/flight/newFligthApi/buyer_dom_manage_order_change_log_list";

import OrderInfo from "./components/inlandOrderInfo";
import ChangeInfo from "./components/changeOrderInfo";
import RefundInfo from "./components/refundOrderInfo";

export default {
  data() {
    return {
      detailData: null,
      loading: true,
      orderNo: "",
      orderStatus: "",
      orderStatusText: "",
      flightType: "1",
      passengers: [],
      activeName: "first",
      tableData: [],
      orderType: null,
      logListForm: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      }
    };
  },
  components: { OrderInfo, ChangeInfo, RefundInfo },
  methods: {
    back() {
      this.$router.go(-1)
    },
    handleSizeChange(val) {
      this.logListForm.pageSize = val;
      this.getLogList(this.detailData);
    },
    handleCurrentChange(val) {
      this.logListForm.currentPage = val;
      this.getLogList(this.detailData);
    },
    GetdetailData() {
      this.detailData = null;
      if (!this.orderType) {
        return detail({ orderNo: this.orderNo })
          .then(res => {
            this.detailData = res.orderDetail;
            this.detailData.fullReductionSnapshot
              ? (this.detailData.fullReductionSnapshot = JSON.parse(
                  this.detailData.fullReductionSnapshot
                ))
              : "";
            this.loading = false;
            return res.orderDetail;
          })
          .catch(() => {
            this.loading = false;
          });
      } else if (this.orderType == "change") {
        return changeOrderDetail({
          chaOrderNo: this.orderNo,
          psgNoList: this.psgNo
        })
          .then(res => {
            this.detailData = res.detailResult;
            this.detailData.img = res.detailResult.url.split(",")[0];
            this.detailData.imgList = res.detailResult.url.split(",");
            this.detailData.fullReductionSnapshot
              ? (this.detailData.fullReductionSnapshot = JSON.parse(
                  this.detailData.fullReductionSnapshot
                ))
              : "";
            this.loading = false;
            return res.changeDetailRes;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        return refundOrderDetail({ refOrderNo: this.orderNo })
          .then(res => {
            this.detailData = res.refundDetailRes;
            this.detailData.img = res.refundDetailRes.url.split(",")[0];
            this.detailData.imgList = res.refundDetailRes.url.split(",");
            this.detailData.fullReductionSnapshot
              ? (this.detailData.fullReductionSnapshot = JSON.parse(
                  this.detailData.fullReductionSnapshot
                ))
              : "";
            this.loading = false;
            return res.refundDetailRes;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getLogList(val) {
      let data;
      if (!this.orderType) {
        data = Object.assign({ orderNo: val }, this.logListForm);
        LogList(data).then(res => {
          this.tableData = res.pageResult.pageData;
          this.logListForm.totalCount = res.pageResult.totalCount;
        });
      } else if (this.orderType == "change") {
        data = Object.assign({ changeId: val }, this.logListForm);
        changeLog(data).then(res => {
          // console.log("改签", res);
          this.tableData = res.pageResult.pageData;
          this.logListForm.totalCount = res.pageResult.totalCount;
        });
      } else {
        data = Object.assign({ bizOrderNo: val }, this.logListForm);
        refundLog(data).then(res => {
          // console.log("退票", res);
          this.tableData = res.pageResult.pageData;
          this.logListForm.totalCount = res.pageResult.totalCount;
        });
      }
    },
    getDate(val) {
      return this.$moment(val).format("YYYY-MM-DD hh:mm:ss");
    }
  },
  activated() {
    this.orderNo = this.$route.query.ordersNo;
    this.orderType = this.$route.query.orderType || "";
    let psgNo = this.$route.query.psgNo || "";
    if (psgNo === '') {
      this.psgNo = psgNo
    } else {
      this.psgNo = JSON.parse(psgNo)
    }
    let val = this.GetdetailData();
    this.getLogList(this.orderNo);
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    console.log(to, from)
    if (to.name === 'air-ticket-admin-purchase-order-list') {
      next()
    } else {
      next({name: 'air-ticket-admin-purchase-order-list'})
    }
  }
};
</script>

<style lang="less" scoped>
.airDetails {
  width: 100%;
}
.el-button {
  border-radius: 0;
}
/deep/.el-tabs__header {
  margin-bottom: 10px;
}
.page {
  margin: 10px;
}
</style>

